<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-all-themes">
    <tl-header></tl-header>
    <div class="wrapper-content-all-themes">
      <span class="title-all-themes">{{'SEARCH.all_list_themes' | translate}}</span>
      <div class="wrapper-custom-search">
        <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
        <input type="text" [placeholder]="'GENERAL.search' | translate" [(ngModel)]="searchTerm" (input)="onSearchChange($event)">
        <div (click)="resetSearch()" class="wrapper-delete-search">
          <img src="../../../assets/icons/outline/icon-close.svg" alt="">
        </div>
      </div>
      <div class="wrapper-list-all-themes" #themesContainer (scroll)="onScroll()">
        <div class="grid">
          <div *ngFor="let theme of themes" [routerLink]="[PAGES_AND_PATHS.singleTheme.pagePath, theme.id]" class="grid__s-4">
            <div class="wrapper-card-theme" [style.background-color]="theme?.color">
              <div class="wrapper-theme-info">
                <span>{{theme.name}}</span>
              </div>
              <img *ngIf="theme" [src]="theme.image_url !== null ? theme.image_url : 'assets/images/no-image.png'" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
